"use client";
import React from "react";
import Image from "next/image";
import styles from "./resources.module.css";

export interface ResourceCardProps {
  title: string;
  description: string;
  icon?: string;
  iconAlt: string;
}

const ResourceCard: React.FC<ResourceCardProps> = ({
  title,
  description,
  icon,
  iconAlt,
}) => {
  return (
    <article
      className={`flex flex-col items-center gap-6 p-6 rounded-lg border text-center ${styles.cardBorder} transition-shadow hover:shadow-lg`}
    >
      {icon && (
        <div
          className={`w-11 h-11 rounded-lg flex items-center justify-center ${styles.iconBackground}`}
        >
          {icon.endsWith('.svg') || icon.includes('.svg') ? (
            // Use regular img tag for SVGs - Next.js Image doesn't optimize SVGs well
            <img
              src={icon}
              alt=""
              width={22}
              height={22}
              className={styles.iconColor}
              aria-hidden="true"
            />
          ) : (
            // Use Next.js Image for other formats
            <Image
              src={icon}
              alt=""
              width={22}
              height={22}
              className={styles.iconColor}
              aria-hidden="true"
              unoptimized={icon.endsWith('.svg') || icon.includes('.svg')}
            />
          )}
        </div>
      )}
      <div className="flex flex-col gap-2">
        <h3 className="font-bold text-white text-base leading-6">{title}</h3>
        <p className="text-slate-300 text-base leading-6 font-normal">
          {description}
        </p>
      </div>
    </article>
  );
};

export default ResourceCard;
